import { render, staticRenderFns } from "./MedicalGuideManagement.vue?vue&type=template&id=12a2b20a&scoped=true"
import script from "./MedicalGuideManagement.vue?vue&type=script&lang=js"
export * from "./MedicalGuideManagement.vue?vue&type=script&lang=js"
import style0 from "./MedicalGuideManagement.vue?vue&type=style&index=0&id=12a2b20a&prod&lang=scss"
import style1 from "./MedicalGuideManagement.vue?vue&type=style&index=1&id=12a2b20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2b20a",
  null
  
)

export default component.exports